(function(){
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- header : ombre au scroll ---- */
  var nav = document.getElementById('nav');
  if(nav){
    var onScroll = function(){ nav.classList.toggle('scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* ---- menu mobile ---- */
  var burger = document.getElementById('burger'), mmenu = document.getElementById('mmenu');
  if(burger && mmenu){
    var setMenu = function(open){
      mmenu.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    };
    burger.addEventListener('click', function(){ setMenu(!mmenu.classList.contains('open')); });
    mmenu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setMenu(false); }); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setMenu(false); });
    window.addEventListener('resize', function(){ if(window.innerWidth > 1020) setMenu(false); });
  }

  /* ---- apparition au scroll ---- */
  var rv = document.querySelectorAll('.rv');
  if(rm || !('IntersectionObserver' in window)){
    rv.forEach(function(e){ e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
    rv.forEach(function(e){ io.observe(e); });
  }

  /* ---- compteurs (section Stats) ---- */
  var statsEl = document.querySelector('.stats-grid');
  if(statsEl){
    var run = function(){
      statsEl.querySelectorAll('[data-count]').forEach(function(el){
        var target = +el.getAttribute('data-count'), suf = el.getAttribute('data-suf') || '', t0 = null, dur = 1200;
        if(rm){ el.textContent = target + suf; return; }
        var tick = function(ts){ if(!t0) t0 = ts; var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * e) + suf; if(p < 1) requestAnimationFrame(tick); };
        requestAnimationFrame(tick);
      });
    };
    if('IntersectionObserver' in window){
      var io2 = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ run(); io2.disconnect(); } }); }, {threshold:.4});
      io2.observe(statsEl);
    } else { run(); }
  }

  /* ---- comparateur avant / après ---- */
  var ba = document.getElementById('ba'), before = document.getElementById('baBefore'), handle = document.getElementById('baHandle');
  if(ba && before && handle){
    var pos = 50, dragging = false;
    var apply = function(p){
      pos = Math.max(0, Math.min(100, p));
      before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      handle.style.left = pos + '%';
      handle.setAttribute('aria-valuenow', Math.round(pos));
    };
    var fromX = function(x){ var r = ba.getBoundingClientRect(); apply((x - r.left) / r.width * 100); };
    ba.addEventListener('pointerdown', function(e){ dragging = true; ba.setPointerCapture(e.pointerId); fromX(e.clientX); });
    ba.addEventListener('pointermove', function(e){ if(dragging) fromX(e.clientX); });
    ba.addEventListener('pointerup', function(){ dragging = false; });
    ba.addEventListener('pointercancel', function(){ dragging = false; });
    handle.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ apply(pos - 5); e.preventDefault(); }
      if(e.key === 'ArrowRight'){ apply(pos + 5); e.preventDefault(); }
    });
    apply(50);
  }

  /* ---- galerie page chantier ---- */
  var thumbs = document.getElementById('pjThumbs');
  if(thumbs){
    var mainPhoto = document.getElementById('pjMainPhoto'), counter = document.getElementById('pjCounter');
    var all = thumbs.querySelectorAll('.pj-thumb'), total = all.length, current = 0;
    var goTo = function(i){
      if(i < 0) i = total - 1; if(i >= total) i = 0; current = i;
      all.forEach(function(b){ b.classList.remove('active'); });
      all[current].classList.add('active');
      mainPhoto.style.opacity = '0';
      setTimeout(function(){
        mainPhoto.src = all[current].getAttribute('data-src');
        mainPhoto.alt = all[current].getAttribute('data-alt') || '';
        mainPhoto.style.opacity = '1';
      }, 160);
      if(counter) counter.textContent = (current + 1) + ' / ' + total;
      all[current].scrollIntoView({behavior: rm ? 'auto' : 'smooth', block:'nearest', inline:'center'});
    };
    all.forEach(function(b, i){ b.addEventListener('click', function(){ goTo(i); }); });
    var prev = document.getElementById('pjPrev'), next = document.getElementById('pjNext');
    if(prev) prev.addEventListener('click', function(){ goTo(current - 1); });
    if(next) next.addEventListener('click', function(){ goTo(current + 1); });
    document.addEventListener('keydown', function(e){
      var t = e.target.tagName; if(t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
      if(e.key === 'ArrowLeft') goTo(current - 1);
      if(e.key === 'ArrowRight') goTo(current + 1);
    });
  }
})();
